import * as Yup from 'yup'
import i18next from 'i18next';
import { createSchema } from '../framework/entity/yup';
import { Carousel } from '../models/Carousel';

const defaultSchema = () => createSchema<Carousel>([
    [x => x.title, Yup.string().nullable().test('title', i18next.t('Titolo mancante'), (value, context) => {        
        return true;
    })],
])

export function getCarouselValidationSchema() {

    let schema = defaultSchema();

    //     if (personRequiredField.birth) {
    //         schema = schema.concat(birthSchema());
    //     }
    
    //     if (personRequiredField.residence) {
    //         schema = schema.concat(residenceSchema());
    //     }
    
    //     if (personRequiredField.identification) {
    //         schema = schema.concat(identificationSchema());
    //     }

    //     if (personRequiredField.custom) {
    //         let list: string[] = personRequiredField.fields ? JSON.parse(personRequiredField.fields) : [];
    //         schema = schema.concat(dynamicSchema(list));
    //     }      

    return schema;
}
